/* eslint-disable prefer-regex-literals */

/**
 * Szöveg trimmelése.
 * @param {string} str - A szöveg.
 * @param {string} [chr] - A karakter, amit trimmelni szeretnénk.
 * @returns {string} A trimmelt szöveg.
 */
module.exports.trim = function trim (str, chr) {
  const rgxtrim = (chr) ? new RegExp(`^${ chr }+|${ chr }+$`, 'g') : new RegExp('^\\s+|\\s+$', 'g')

  return str.replace(rgxtrim, '')
}
